import _classCallCheck from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/createClass";
import Coordinate from '../geom/Coordinate';
import IllegalArgumentException from '../../../../java/lang/IllegalArgumentException';
var Octant = /*#__PURE__*/function () {
  function Octant() {
    _classCallCheck(this, Octant);
  }
  _createClass(Octant, null, [{
    key: "octant",
    value: function octant() {
      if (typeof arguments[0] === 'number' && typeof arguments[1] === 'number') {
        var dx = arguments[0],
          dy = arguments[1];
        if (dx === 0.0 && dy === 0.0) throw new IllegalArgumentException('Cannot compute the octant for point ( ' + dx + ', ' + dy + ' )');
        var adx = Math.abs(dx);
        var ady = Math.abs(dy);
        if (dx >= 0) {
          if (dy >= 0) {
            if (adx >= ady) return 0;else return 1;
          } else if (adx >= ady) return 7;else return 6;
        } else if (dy >= 0) {
          if (adx >= ady) return 3;else return 2;
        } else if (adx >= ady) return 4;else return 5;
      } else if (arguments[0] instanceof Coordinate && arguments[1] instanceof Coordinate) {
        var p0 = arguments[0],
          p1 = arguments[1];
        var _dx = p1.x - p0.x;
        var _dy = p1.y - p0.y;
        if (_dx === 0.0 && _dy === 0.0) throw new IllegalArgumentException('Cannot compute the octant for two identical points ' + p0);
        return Octant.octant(_dx, _dy);
      }
    }
  }]);
  return Octant;
}();
export { Octant as default };